<template>
    <div class="content-container">
        <div class="header">
            <div class="title">Menu</div>
        </div>        
        <div class="content nopad">            
            <div class="sidebar-menu">
                <ul>
                    <li v-bind:class="selectedStateHome" v-on:click="$emit('show-content', 'home'); selectHome()"><span class="menutext">HOME</span></li>
                    <li v-bind:class="selectedStateMembers" v-on:click="$emit('show-content', 'members'); selectMembers()"><span class="menutext">MEMBERS</span></li>
                    <li v-bind:class="selectedStateSite" v-on:click="$emit('show-content', 'site'); selectSite()"><span class="menutext">SITE</span></li>
                </ul>
            </div>
        </div>
        <div class="content">
        
        </div>        
    </div>
</template>

<script>

    export default {

        data() {
            return {
                currentSelection: 'home'
            }
        },

        computed: {
            selectedStateHome: function() {
                return this.currentSelection === 'home' ? 'selected' : null;
            },
            selectedStateMembers: function() {
                return this.currentSelection === 'members' ? 'selected' : null;
            },
            selectedStateSite: function() {
                return this.currentSelection === 'site' ? 'selected' : null;
            }
        },

        methods: {
            selectHome: function() {
                this.currentSelection = "home";
            },
            selectMembers: function() {
                this.currentSelection = "members";
            },
            selectSite: function() {
                this.currentSelection = "site";
            }
        }
    }

</script>